<div class="fadeinright animation-duration-200">
  <div class="px-5 pt-2">
    <div class="flex text-center">
      <h2>Para continuar, necesitamos que tengas instalada la app de Krediya para que puedas reportar tus pagos.</h2>
    </div>
    <div class="flex justify-content-center align-items-center">
      <p>En este punto ya deberías tener instalada la app y te pedirá estos datos:</p>
    </div>
    <div class="flex w-full md:flex-column justify-content-between align-items-center">
          <div class="flex flex-column align-items-start">
            <p class="text-sm">N° de contrato</p>
            <label class="font-bold text-lg">{{contractNumber}}</label>
          </div>

          <div class="flex flex-column align-items-end md:align-items-start">
            <p class="text-sm">N° de cliente</p>
            <label class="font-bold text-lg">{{person?.number}}</label>
          </div>
    </div>
    <div class="flex justify-content-center align-items-center mt-5">
      <p-button (onClick)="onNextStep()">
        <label class="text-sm font-bold cursor-pointer">Ya introduje los datos en la app</label>
      </p-button>
    </div>
    <div class="flex flex-column justify-content-center align-items-center mt-6">
      <p>Si aun no la tienes instalada, puedes hacerlo presionando abajo <i class="pi pi-arrow-down"></i></p>
    </div>
    <div class="flex justify-content-center align-items-center mt-1">
      <p-button severity="secondary" [outlined]="true"  label="Ir a descar la app" (onClick)="downLoadApp()"></p-button>
    </div>
  </div>
</div>
